import styled from "styled-components";
import { Field } from "redux-form/immutable";

import { renderEditor } from "../../up-code-editor";
import type {
  ConditionFilterProps,
  ConditionProduct
} from "../utils";

const Filter = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  @media only screen and (max-width: 680px) {
    flex-direction: column;
    align-items: stretch;
  }
  @media only screen and (max-width: 550px) {
    flex-direction: row;
    margin-left: 0px;
    align-items: center;
  }
  @media only screen and (max-width: 470px) {
    flex-direction: column;
    align-items: stretch;
    width: auto;
  }
`;

interface ConditionProps extends ConditionFilterProps {
  product: ConditionProduct;
}

const Condition = ({ member, product }: ConditionProps) => (
  <Filter>
    <Field
      name={`${member}.value`}
      component={renderEditor}
      placeholder="JavaScript Code"
      height="100px"
      givenSignature="()=>{"
      mode="javascript"
      validateCustom={{
        editor: true,
        dom: product === "mail"
      }}
      errorIcon={{
        top: "85%",
        right: "20px"
      }}
    />
  </Filter>
);

export default Condition;
